// extracted by mini-css-extract-plugin
module.exports = {"switch":"checkbox_switch__ngt6d","label":"checkbox_label__ZvZlW","tick":"checkbox_tick__LTDLG"};